import React, { useEffect, useState } from "react";
import {
  Route,
  BrowserRouter,
  Routes,
  useParams,
  useNavigate,
  matchPath,
} from "react-router-dom";
import EmployerHome from "../company/home";
import CompanyProfile from "../company/profile";
import ManageJobs from "../company/manageJob";
import Response from "../company/response";
import EmployeeHomePage from "../user/home";
import JobDetail from "../user/jobdetail";
import JobSearch from "../user/jobs";
import UserProfile from "../user/profile";
import AdminDashboard from "../admin/dashboard";
import Job from "../admin/job";
import Category from "../admin/category";
import Employee from "../admin/employee";
import Employer from "../admin/employer";
import EmployeeSearch from "../company/employeeSearch";
import ManageAdmin from "../admin/manageadmin";
import Followup from "../admin/followup";
import AdminLoginFrom from "../admin/login";
import FilterList from "../admin/filterList";
import ResumeGrerator from "../admin/Resume";
import ManageInterview from "../admin/interview";
import JobResponse from "../admin/response";
import NotFound from "./notfound";
import ResetPassword from "./resetPassword";
import EmailTemplate from "../admin/email";
import Loader from "../common/loader";
import { LinkedInCallback } from "react-linkedin-login-oauth2";
import Visa from "../admin/visa";
import Document from "../admin/document";
import EmployerLMIA from "../company/lmia";
import SelfApplicat from "../admin/selfApplicat";
import SelfJob from "../admin/selfJob";
import LimaContainer from "../admin/lmiaContainer";
import NewUserProfile from "../user/user_profile";
import CompanyProfileDetail from "../company/company_profile";
import JobDetailpageAdmim from "../admin/job_Detail_page";
import PDFViewer from "../user/user_pdf";
import JobAssignedDashboard from "../admin/jobAssignedDashboard";
import RazorPay from "./payButton";
import Agent from "../admin/agent";
import Notes from "../admin/notes";
import AgentLogin from "../agent/agentLogin";
import MainEmailPage from "../email/mainemailPage";
import SinUpPage from "../user/sinUpPage";
import CandidateLoginForm from "../user/candidate_login";
import CandidateSignup from "../user/candidate_signup";
import CompanyLoginForm from "../company/company_login";
import CompanySingupForm from "../company/company_singup";
import GoogleDrive from "./googleDrive";
import Anotation from "./anotation";
import BusinessVIsa from "../admin/businessVisa";
import ExpressEntry from "../admin/expressEntry";
import VisitorVisa from "../admin/visitorVisa";
import Pnp from "../admin/pnp";
import PartnerDashboard from "./partner_dashboard";
import ActivityLog from "./activity_log";
import Credentional from "../admin/Credentional";
import AsiignedAdmin from "./asiigned_admin";
import Federalpr from "../admin/federalpr";
import PartnerDetails from "../agent/partnerDetails";
import SharePointDocument from "./Document folder/SharePointDocument";
import Newpdf from "./Adobe/newpdf";
import ExpressEntryPdf from "./Retaineragreement/Agreement native/ExpressEntryPdf";
import SignaturePadComponent from "./Retaineragreement/SignaturePadComponent";
import ExpressEntryHtml from "./Retaineragreement/Html/ExpressEntryHtml";
import WebhookComponent from "./webHook";
import { ToastContainer } from "react-toastify";
import UserSigningPage from "./Retaineragreement/UserSigningPage";
import AboutUs from "../user/AboutUs";
import LocalCandidate from "../admin/localCandidate";
import PGWP from "../admin/pgwp";
import DemoJob from "../user/demoJob";
import StudyPermit from "../admin/studyPermit";
import ViewPdf from "./Retaineragreement/viewPdf";
import TemporaryResident from "../admin/TemporaryResident";
import EconomicImmigration from "../admin/EcomonicImmigration";
import FamilySponsorship from "../admin/FamilySponsorship";
import ManageTask from "../admin/manageTask";
import Humanitarian from "../admin/humanitarian";
import TypePassport from "../admin/typePassport";
import TypeCitizenship from "../admin/typeCitizenship";
import ParmanentResidentCard from "../admin/ParmanentResidentCard";
import StudyHome from "../Study/StudyComman/studyHome";
import StudentProfile from "../Study/student/studentProfile";
import StudentDocument from "../Study/student/studentDocument";
import MainHomePage from "../Study/mainHomePage";
import Programs from "../Study/student/programs";
import EducationLoan from "../Study/student/educationLoans";
import PersonalLoan from "../Study/student/personalLoan";
import Accommodation from "../Study/student/accommodation";
import StudyDashboard from "../Study/Study admin/studyDashboard";
import StudentList from "../Study/Study admin/studentsList";
import StudyAdminLoginFrom from "../Study/Study admin/studyAdminLogin";
import AppliedPrograms from "../Study/Study admin/appliedPrograms";
import StudyPartnerLogin from "../Study/StudyComman/studyPartnerLogin";
import InitialConsultationAgreement from "./Retaineragreement/Agreement native/initialConsulation";
import RecruitmentAgrement from "./Retaineragreement/Agreement native/RecruitmentAgrement";
import Wes from "../admin/wes";
import Atip from "../admin/atip";
import CommonApplicatTypePage from "./CommonApplicatTypePage";
import MangeApplicantType from "../admin/MangeApplicantType";
import ManageDailyCallLog from "../admin/ManageDailyCallLog";
import ManagePayment from "../admin/ManagePaymentInvoices";
import RenewalApplicantionsPdf from "./Retaineragreement/Agreement native/RenewalApplicantionsPdf";
import MoreThanOneApplicantAgreementPdf from "./Retaineragreement/Agreement native/MoreThanOneApplicantAgreementPdf";
import EmployerRetainerAgreementPdf from "./Retaineragreement/Agreement native/EmployerRetainerAgreementPdf";
import ThreeColumnRerainerAgreement from "./Retaineragreement/Agreement native/ThreeColumnRerainerAgreement";
import ManageHourlyLog from "../admin/ManageHourlyLog";
import ConvertAnyFileToPdf from "./Common function/ConvertAnyFileTopdf";
import WorkPermitPdf from "./Retaineragreement/Agreement native/WorkPermitPdf";
import AlbertaPnpPdf from "./Retaineragreement/Agreement native/AlbertaPnpPdf";
import AdminMain from "../admin/AdminMain";
import CommonAdminExtraLinkSetting from "../admin/CommonAdminExtraLinkSetting";
import ManageConsultation from "../admin/ManageConsultation";
import CommonDailyPage from "./CommonDailyPage";
import WorkPermitApplicantTwoStagePdf from "./Retaineragreement/Agreement native/WorkPermitApplicantTwoStagePdf";
import DynamicRA from "./Retaineragreement/Agreement native/DynamicRA"
// import PreviewEmail from "../email/emailPreview";
// function CurrentRoute() {
//   const path = location.pathname;
//   // Use the path variable in your component
//   return path;
// }
// const location = useLocation();
function MainLayout() {
  const [loginCondition, setLoginCondition] = useState(false);
  const token = localStorage.getItem("token");
  const userType = localStorage.getItem("userType");
  const employeeId = localStorage.getItem("employee_id"); // Assuming employee_id is stored in localStorage

  /*Function to check the employee profile with just its id  */
  const ValidateRoute = () => {
    const { eid } = useParams();
    const isValidEid = /^\d+$/.test(eid); // Check if eid is a number

    if (userType === "user" && eid === employeeId && isValidEid) {
      return <NewUserProfile setLoginCondition={setLoginCondition} />;
    } else if (isValidEid && userType !== "user") {
      return <NewUserProfile />;
    } else {
      return <NotFound userType={userType} />;
    }
  };

  function RouterHandler({ token, userType, employeeId }) {
    const navigate = useNavigate();
    const path = window.location.pathname;

    const allowedPaths = {
      admin: [
        "/dashboard", "/job", "/selfjob", "/category", "/lmia", "/visa", "/document", "/employee", "/selfemployee",
        "/adminclient", "/adminprofile", "/assignedjobs", "/:eid", "/userpdf", "/managetasks", "/sharepoint_document",
        "/client_detail", "/job_detail", "/partner_profile", "/followup", "/partner", "/partner_dashboard", "/daily_call_log",
        "/daily_hours_log", "/consultation", "/assigned_admin", "/activity_log", "/filter", "/interview", "/responses",
        "/lmia_dashboard", "/emailtemplate", "/notes", "/credentials", "/testpdfurl", "/resume/:id", "/daily_pages", "/email",
        "/googledrive", "/anotation", "/slots", "/setting", "/manage_applicant_type", "/businessvisa", "/expressentry",
        "/visitorsvisa", "/studypermit", "/temporaryresident", "/economicimmigration", "/familysponsorship", "/pnp", "/passport",
        "/citizenship", "/humanitarian_and_Compassionate", "/permanent_resident_cards", "/pgwp", "/wes", "/atip", "/localcandidates",
        "/federal_pr", "/view_pdf_Agreement", "/study_dashboard", "/programs", "/students", "/student_profile", "/applied_programs",
        "/payment_invoice"
      ],
      user: [
        `/${employeeId}`, "/", "/student_profile", "/student_document", "/programs", "/education_loan", "/personal_loan", "/accommodation",
        "/jobs", "/jobdetail", "/profile", "/:eid", "/job_detail", "/client_detail", "/userpdf", "/view_pdf_Agreement", "/resume/:id"
      ],
      company: [
        `/${employeeId}`, "/:eid", "/client_detail", "/clientprofile", "/managejobs", "/response", "/empsearch", "/profile", "/lmia", "/resume/:id",
        "/job_detail", "/view_pdf_Agreement"
      ],
      agent: [ // same as admin list, assuming they share same paths
        `/${employeeId}`, "/partner_dashboard", "/job", "/selfjob", "/category", "/lmia", "/visa", "/document", "/employee", "/selfemployee",
        "/adminclient", "/adminprofile", "/assignedjobs", "/:eid", "/userpdf", "/managetasks", "/sharepoint_document",
        "/client_detail", "/job_detail", "/partner_profile", "/followup", "/partner", "/partner_dashboard", "/daily_call_log",
        "/daily_hours_log", "/consultation", "/assigned_admin", "/activity_log", "/filter", "/interview", "/responses",
        "/lmia_dashboard", "/emailtemplate", "/notes", "/credentials", "/testpdfurl", "/resume/:id", "/daily_pages", "/email",
        "/googledrive", "/anotation", "/slots", "/setting", "/manage_applicant_type", "/businessvisa", "/expressentry",
        "/visitorsvisa", "/studypermit", "/temporaryresident", "/economicimmigration", "/familysponsorship", "/pnp", "/passport",
        "/citizenship", "/humanitarian_and_Compassionate", "/permanent_resident_cards", "/pgwp", "/wes", "/atip", "/localcandidates",
        "/federal_pr", "/view_pdf_Agreement", "/study_dashboard", "/programs", "/students", "/student_profile", "/applied_programs",
        "/payment_invoice"
      ]
    };

    const redirectPath = {
      admin: "/dashboard",
      user: `/${employeeId}`,
      company: "/client_detail",
      agent: "/partner_dashboard"
    };

    useEffect(() => {
      if (!token || token === "null" || token === "undefined") return;
      const allowed = allowedPaths[userType] || [];
      const isAllowed = allowed.some((allowedPath) => matchPath(allowedPath, path));
      if (!isAllowed) {
        navigate(redirectPath[userType]);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, userType, path, navigate]);

    return null;
  }

  return (
    <BrowserRouter>
      <ToastContainer />
      {/* <CurrentRoute /> */}
      <RouterHandler token={token} userType={userType} employeeId={employeeId} />
      <Routes>
        {/* Employee */}
        <Route path="/" element={<EmployeeHomePage />} />
        <Route path="/main_home" element={<MainHomePage />} />
        <Route path="/study" element={<StudyHome />} />
        <Route path="/signup" element={<SinUpPage />} />
        <Route
          path="/candidate_login"
          element={<CandidateLoginForm setLoginCondition={setLoginCondition} />}
        />
        <Route path="/candidate_signup" element={<CandidateSignup />} />
        <Route
          path="/client_login"
          element={<CompanyLoginForm setLoginCondition={setLoginCondition} />}
        />
        <Route path="/client_singup" element={<CompanySingupForm />} />
        <Route path="/rozarepay" element={<RazorPay />} />
        <Route path="/jobs" element={<JobSearch />} />
        <Route path="/jobdetail" element={<JobDetail />} />
        <Route path="/outside_booking" element={<WebhookComponent />} />
        <Route path="/resetpassword/:id" element={<ResetPassword />} />
        <Route exact path="/linkedin" component={LinkedInCallback} />
        <Route exact path="/signagreement" element={<UserSigningPage />} />
        <Route path="/agreeone" element={<ExpressEntryPdf />} />
        <Route path="/dynamic_ra" element={<DynamicRA />} />
        <Route path="/work_permit_application_2_stage" element={<WorkPermitApplicantTwoStagePdf />} />
        <Route
          path="/initial_consultation"
          element={<InitialConsultationAgreement />}
        />
        <Route path="/recruitment_service" element={<RecruitmentAgrement />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/demojob" element={<DemoJob />} />

        {/* <Route path="*" element={<NotFound userType={userType}/>} /> */}
        {userType === "user" &&
          (token !== "" ||
            token !== null ||
            token !== undefined ||
            token !== "null" ||
            token !== "undefined") ? (
          <>
            <Route
              path="/student_profile"
              element={<StudentProfile setLoginCondition={setLoginCondition} />}
            />
            <Route path="/student_document" element={<StudentDocument />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/education_loan" element={<EducationLoan />} />
            <Route path="/personal_loan" element={<PersonalLoan />} />
            <Route path="/accommodation" element={<Accommodation />} />
            <Route
              path="/"
              element={
                <EmployeeHomePage setLoginCondition={setLoginCondition} />
              }
            />
            <Route path="/jobs" element={<JobSearch />} />
            <Route path="/jobdetail" element={<JobDetail />} />
            <Route path="/profile" element={<UserProfile />} />
            <Route path="/:eid" element={<ValidateRoute />} />
            <Route path="*" element={<NotFound userType={userType} />} />
            <Route path="/job_detail" element={<JobDetailpageAdmim />} />
            <Route path="/client_detail" element={<CompanyProfileDetail />} />
            <Route path="/userpdf" element={<PDFViewer />} />
            <Route path="/view_pdf_Agreement" element={<ViewPdf />} />
            <Route path="/resume/:id" element={<ResumeGrerator />} />
          </>
        ) : (
          <>
            <Route path="/" element={<EmployeeHomePage />} />
            <Route path="/jobs" element={<JobSearch />} />
            <Route path="/jobdetail" element={<JobDetail />} />
            {/* <Route path="*" element={<NotFound userType={userType}/>} /> */}
          </>
        )}
        {/* Employer */}
        {userType === "company" &&
          (token !== "" ||
            token !== null ||
            token !== undefined ||
            token !== "null" ||
            token !== "undefined") ? (
          <>
            <Route
              path="/client"
              element={<EmployerHome setLoginCondition={setLoginCondition} />}
            />
            <Route path="/clientprofile" element={<CompanyProfile />} />
            <Route path="/managejobs" element={<ManageJobs />} />
            <Route path="/response" element={<Response />} />
            <Route path="/empsearch" element={<EmployeeSearch />} />
            <Route path="/profile" element={<UserProfile />} />
            <Route path="/:eid" element={<ValidateRoute />} />
            {/* <Route path="/lmia_dashboard" element={<EmployerLMIA />} /> */}
            <Route path="/lmia" element={<LimaContainer />} />
            <Route path="/resume/:id" element={<ResumeGrerator />} />
            <Route path="*" element={<NotFound userType={userType} />} />
            <Route path="/job_detail" element={<JobDetailpageAdmim />} />
            <Route path="/userpdf" element={<PDFViewer />} />
            <Route path="/client_detail" element={<CompanyProfileDetail />} />
            <Route path="/view_pdf_Agreement" element={<ViewPdf />} />
          </>
        ) : (
          <>
            <Route path="/" element={<EmployeeHomePage />} />
            {/* <Route path="*" element={<NotFound userType={userType}/>} /> */}
          </>
        )}
        {/* Agent */}
        <Route
          path="/partnerlogin"
          element={<AgentLogin setLoginCondition={setLoginCondition} />}
        />
        {/* Study partner login page */}
        <Route
          path="/study_partner_login"
          element={<StudyPartnerLogin setLoginCondition={setLoginCondition} />}
        />
        {/* Admin */}
        <Route
          path="/adminlogin"
          element={<AdminLoginFrom setLoginCondition={setLoginCondition} />}
        />
        <Route
          path="/study_admin_login"
          element={
            <StudyAdminLoginFrom setLoginCondition={setLoginCondition} />
          }
        />
        <Route path="/agreepreivew" element={<ExpressEntryHtml />} />
        <Route
          path="/more_than_one_applicant"
          element={<MoreThanOneApplicantAgreementPdf />}
        />
        <Route
          path="/renewal_application"
          element={<RenewalApplicantionsPdf />}
        />
        <Route
          path="/employers_agreement"
          element={<EmployerRetainerAgreementPdf />}
        />
        <Route
          path="/three_column"
          element={<ThreeColumnRerainerAgreement />}
        />
        <Route path="/work_permit" element={<WorkPermitPdf />} />
        <Route path="/alberta_pnp" element={<AlbertaPnpPdf />} />

        <Route path="/addsign" element={<SignaturePadComponent />} />
        {(userType === "company" ||
          userType === "user" ||
          userType === "" ||
          userType === null ||
          userType === "null") &&
          (token === "" ||
            token === null ||
            token === undefined ||
            token === "null") ? (
          <>
            <Route path="/" element={<EmployeeHomePage />} />
            {/* <Route path="*" element={<NotFound userType={userType}/>} /> */}
          </>
        ) : (
          <>
            {userType !== "admin" || userType === ""}
            {/* Layout Route */}
            <Route path="/resume/:id" element={<ResumeGrerator />} />
            <Route element={<AdminMain />}>
              <Route
                path="/dashboard"
                element={
                  <AdminDashboard setLoginCondition={setLoginCondition} />
                }
              />
              <Route path="/job" element={<Job />} />
              <Route path="/selfjob" element={<SelfJob />} />
              <Route path="/category" element={<Category />} />
              <Route path="/lmia" element={<LimaContainer />} />
              <Route path="/visa" element={<Visa />} />
              <Route path="/document" element={<Document />} />
              <Route path="/employee" element={<Employee />} />
              <Route path="/selfemployee" element={<SelfApplicat />} />
              <Route path="/adminclient" element={<Employer />} />
              <Route path="/adminprofile" element={<ManageAdmin />} />
              <Route path="/assignedjobs" element={<JobAssignedDashboard />} />
              <Route path="/:eid" element={<ValidateRoute />} />
              <Route path="/userpdf" element={<PDFViewer />} />
              <Route path="/managetasks" element={<ManageTask />} />
              <Route
                path="/sharepoint_document"
                element={<SharePointDocument />}
              />
              <Route path="/job_detail" element={<JobDetailpageAdmim />} />
              <Route path="/client_detail" element={<CompanyProfileDetail />} />
              <Route
                path="/partner_profile"
                element={
                  <PartnerDetails setLoginCondition={setLoginCondition} />
                }
              />
              <Route path="/followup" element={<Followup />} />
              <Route path="/partner" element={<Agent />} />
              <Route path="/partner_dashboard" element={<PartnerDashboard />} />
              <Route path="/daily_call_log" element={<ManageDailyCallLog />} />
              <Route path="/daily_hours_log" element={<ManageHourlyLog />} />
              <Route path="/consultation" element={<ManageConsultation />} />
              <Route path="/assigned_admin" element={<AsiignedAdmin />} />
              <Route path="/activity_log" element={<ActivityLog />} />
              <Route path="/filter" element={<FilterList />} />
              <Route path="/interview" element={<ManageInterview />} />
              <Route path="/responses" element={<JobResponse />} />
              <Route path="/lmia_dashboard" element={<EmployerLMIA />} />
              <Route path="/emailtemplate" element={<EmailTemplate />} />
              <Route path="/notes" element={<Notes />} />
              <Route path="/credentials" element={<Credentional />} />
              <Route path="/testpdfurl" element={<ConvertAnyFileToPdf />} />
              <Route path="/daily_pages" element={<CommonDailyPage />} />
              <Route path="/email" element={<MainEmailPage />} />
              <Route path="*" element={<NotFound userType={userType} />} />
              <Route path="/googledrive" element={<GoogleDrive />} />
              <Route path="/anotation" element={<Anotation />} />
              <Route path="/slots" element={<CommonApplicatTypePage />} />
              <Route path="/setting" element={<CommonAdminExtraLinkSetting />} />
              <Route
                path="/manage_applicant_type"
                element={<MangeApplicantType />}
              />
              <Route path="/businessvisa" element={<BusinessVIsa />} />
              <Route path="/expressentry" element={<ExpressEntry />} />
              <Route path="/visitorsvisa" element={<VisitorVisa />} />
              <Route path="/studypermit" element={<StudyPermit />} />
              <Route
                path="/temporaryresident"
                element={<TemporaryResident />}
              />
              <Route
                path="/economicimmigration"
                element={<EconomicImmigration />}
              />
              <Route
                path="/familysponsorship"
                element={<FamilySponsorship />}
              />
              <Route path="/pnp" element={<Pnp />} />
              <Route path="/passport" element={<TypePassport />} />
              <Route path="/citizenship" element={<TypeCitizenship />} />
              <Route
                path="/humanitarian_and_Compassionate"
                element={<Humanitarian />}
              />
              <Route
                path="/permanent_resident_cards"
                element={<ParmanentResidentCard />}
              />
              <Route path="/pgwp" element={<PGWP />} />
              <Route path="/wes" element={<Wes />} />
              <Route path="/atip" element={<Atip />} />
              <Route path="/localcandidates" element={<LocalCandidate />} />
              <Route path="/federal_pr" element={<Federalpr />} />
              <Route path="/view_pdf_Agreement" element={<ViewPdf />} />
              {/* Study pages as for admin */}
              <Route path="/study_dashboard" element={<StudyDashboard />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/students" element={<StudentList />} />
              <Route path="/student_profile" element={<StudentProfile />} />
              <Route path="/applied_programs" element={<AppliedPrograms />} />
              <Route path="*" element={<Loader load={"yes"} />} />
              <Route path="/payment_invoice" element={<ManagePayment />} />
              {/* <Route path="/:eid" element={<NewUserProfile />} /> */}
            </Route>

            {/* <Route path="/*" element={<AdminMain />} /> */}
          </>
        )}
        <Route path="/Newpdf" element={<Newpdf />} />

        {loginCondition === true ? null : (
          <Route path="*" element={<NotFound userType={userType} />} />
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default MainLayout;
